import React from 'react';
import { Card } from '@dopomogai/ui';
import type { AgentPerformanceMetrics } from '@dopomogai/types';

type Props = {
  metrics?: AgentPerformanceMetrics | null;
  supporterCount?: number;
  roadmap?: { title: string; date?: string }[];
};

export function TrustSignals({ metrics, supporterCount, roadmap = [] }: Props) {
  return (
    <section className="max-w-6xl mx-auto px-6 py-8">
      <Card>
        <div className="p-4 grid md:grid-cols-3 gap-4">
          <div>
            <div className="text-xs text-slate-600">Supporters</div>
            <div className="text-xl font-extrabold">{supporterCount ?? 0}</div>
          </div>
          <div>
            <div className="text-xs text-slate-600">Total earnings</div>
            <div className="text-xl font-extrabold">{metrics?.total_earnings_credits ?? 0} cr</div>
          </div>
          <div>
            <div className="text-xs text-slate-600">Updates</div>
            <div className="space-y-1 text-sm text-slate-700">
              {roadmap.slice(0, 3).map((r, i) => (
                <div key={i}>• {r.title}{r.date ? ` — ${r.date}` : ''}</div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </section>
  );
}


